import * as z from "zod";
const PluginConfigBaseSchema = z
    .object({
    apiVersionRequired: z.string(),
    pluginPath: z.string(),
    id: z.string(),
})
    .catchall(z.unknown());
class PluginBase {
    constructor(apiVersionProvided) {
        this.apiVersionProvided = apiVersionProvided;
        this.id = `plugin`;
    }
}
export { PluginConfigBaseSchema, PluginBase };
